export enum CancelEmailChangeConfirmationUserAction {
  CANCEL,
  CONFIRM,
  ERROR,
}

export enum CancelEmailChangeConfirmationToastAlert {
  SUCCESS = 'cancel-email-change-confirmation-success-toast-alert',
  NOT_FOUND_ERROR = 'cancel-email-change-confirmation-not-found-toast-alert',
  DEFAULT_ERROR = 'cancel-email-change-confirmation-default-error-toast-alert',
}
